import { useContext, createContext } from 'react';
var GridContext = createContext(null);
var GridProvider = GridContext.Provider;

var useGridContext = function useGridContext() {
  return useContext(GridContext);
};

export { GridProvider, useGridContext };